<template>
  <div class="contacto">
    <v-alert
      class="alert-cart"
      height="50"
      transition="fade-transition"
      v-model="contactoAlert"
      color="#A37E60"
    >
      <span>El mensaje ha sido enviado correctamente; nos comunicaremos en breve contigo</span>
      <div class="centrar-right"></div>
    </v-alert>

    <v-container fluid class="py-0 contacto-container">
      <v-row>
        <v-col cols="12" md="6" class="py-0">
          <div class="contacto-img-border">
            <v-img
              src="@/assets/img/Contacto-PeaceLilyClose.jpg"
              class="contacto-img"
              position="center"
            ></v-img>
          </div>
        </v-col>

        <v-col cols="12" md="6" class="py-0 contacto-col-verde">
          <v-row justify="center">
            <v-col cols="10" md="8">
              <v-form lazy-validation ref="form" v-model="valid">
                <div>
                  <div class="text-center mt-8">
                    <span>contacto</span>
                  </div>

                  <div class="mx-auto mt-8" style="text-transform: none">
                    <span>Escríbenos, nos dará mucho gusto resolver cualquier duda o la oportunidad de compartir contigo nuestra pasión por nuestras green roomies</span>
                  </div>
                </div>

                <div class="mt-8">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <label for>nombre</label>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field dark v-model="nombre" :rules="nombreRules"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mt-2">
                    <v-col cols="12" class="py-0">
                      <label for>correo</label>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field dark v-model="correo" :rules="correoRules"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mt-2">
                    <v-col cols="12" class="py-0">
                      <label for>asunto</label>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field dark v-model="asunto" :rules="asuntoRules"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mt-2">
                    <v-col cols="12" class="py-0">
                      <label for>mensaje</label>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field dark v-model="mensaje" :rules="mensajeRules"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mt-8 mb-8">
                    <v-col class="py-0">
                      <v-btn tile elevation="0" width="100%" color="#064434" @click="validate()" :disabled="!valid">
                        <span style="color:white;">enviar</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nombre: "",
      nombreRules:[
        v => !!v || 'Este campo es requerido'
      ],
      correo: "",
      correoRules:[
        v => !!v || 'Este campo es requerido',
        v => /.+@.+\..+/.test(v) || "Email no válido"
      ],
      asunto: "",
      asuntoRules:[
        v => !!v || 'Este campo es requerido'
      ],
      mensaje: "",
      mensajeRules:[
        v => !!v || 'Este campo es requerido'
      ],
      contactoAlert: false,
      valid: true
    };
  },
  methods: {
    validate() {
        if(this.$refs.form.validate()){
            this.contactoAlert = true;

            setTimeout(()=>{
              this.contactoAlert = false  
            }, 8000);

            var datos = {
                Nombre: this.nombre,
                Correo: this.correo,
                Asunto: this.asunto,
                Mensaje: this.mensaje
            };

            console.log(datos);
            fetch('https://www.cpcms.actstudio.xyz/api/forms/submit/contacto?token=c88bdc0ebcb7f81a8c480681c41652', {
              method: "post",
              headers: {"Content-Type" : "application/json"},
              body: JSON.stringify({
                form: datos
              })
            })

            .then(entry => entry.json())
            .then(entry => console.log(entry));

            this.$refs.form.reset();
        }
    }
  },
  mounted: function(){
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Contacto',
      'page_path': '/contacto'
    });
  }
};
</script>